import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { InquiryResponse } from 'backend/types'
import { toast } from 'sonner'
import type { UpdateInquiryRequest } from '@/lib'
import { updateInquiry } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseUpdateInquiryOptions {
  onSuccess?: (data: InquiryResponse) => void
  onError?: (error: Error) => void
}

export function useUpdateInquiry(inquiryId: number, options: UseUpdateInquiryOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateInquiryRequest) => {
      return updateInquiry(inquiryId, data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiries.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assignMembers.all() })
      queryClient.invalidateQueries({ queryKey: ['salesforce-deal-anos'] })
      toast.success('引合を更新しました')
      onSuccess?.(data)
    },
    onError: (error: Error) => {
      notifyMutationError(error, '引合の更新に失敗しました')
      onError?.(error)
    },
  })
}
